import { useMutation, useQueryClient } from "react-query";

import axios from "axios";
import { AUTOMATION_SERVICE_ADDRESS } from "constants/app.constants";

import { AutomationGroup } from "../types/automation";
import { AUTOMATION_COLLECTIONS_QUERY_KEY } from "./useFetchAutomationCollections";

/**
 * Adds a group to an automation collection.
 * @param id - The automation collection ID.
 * @param group - The group to add.
 * @returns The updated automation collection or group, depending on backend response.
 */
const addAutomationGroup = async ({
  id,
  group
}: {
  id: string;
  group: AutomationGroup;
}) => {
  const response = await axios.post(
    `${AUTOMATION_SERVICE_ADDRESS}/automation/${id}/groups`,
    group
  );
  return response.data;
};

export default function useAddAutomationGroup() {
  const queryClient = useQueryClient();
  return useMutation(addAutomationGroup, {
    onSuccess: () => {
      queryClient.invalidateQueries(AUTOMATION_COLLECTIONS_QUERY_KEY);
    }
  });
}
